import styled from '@emotion/styled';

export const Title = styled.h3`
  grid-column: 1/-1;
  grid-row: 1;
  white-space: pre-wrap;
  margin: 1.5em 0;
`;
